import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import FullScreenWindow from '../../components/full-screen-window';
import LoginScreen from '../../components/login-screen';
import { XSmall } from '../../components/icons';
import { closeModal } from '../../actions/close-modal';
import { loginMember } from '../../actions/login-member';
import styles from './login-modal.scss';

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleLogin(member) {
    const { loginMember, closeModal } = this.props;

    return loginMember(member).then(() => closeModal());
  }

  handleClose() {
    this.props.closeModal();
  }

  render() {
    return (
      <FullScreenWindow>
        <div className={styles.container}>
          <LoginScreen onLogin={this.handleLogin} onLoginError={this.handleClose}>
            <button className={styles.closeButton} onClick={this.handleClose}>
              <XSmall/>
            </button>
          </LoginScreen>
        </div>
      </FullScreenWindow>
    );
  }
}

LoginModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  loginMember: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeModal,
  loginMember,
};

export default connect(undefined, mapDispatchToProps)(LoginModal);



// WEBPACK FOOTER //
// ./app/containers/login-modal/login-modal.js